import { to_var } from "../utils/to_var";

export function eqParser(class_name, value) {
  let _type = "";
  let _classes = [];
  let _variable_name;
  let _class_name;
  let _default;

  try {
    _variable_name = to_var(class_name);
    _class_name = to_var(class_name, true);
  } catch (e) {
    console.log(e);
  }

  if (value === null) {
    _type = "String";
    _default = '""';
  } else if (typeof value === "string") {
    _type = "String";
    _default = '""';
  } else if (typeof value === "boolean") {
    _type = "boolean";
    _default = "true";
  } else if (typeof value === "number") {
    if (value % 1 === 0) {
      _type = "int";
      _default = "0";
    } else {
      _type = "double";
      _default = "0.0";
    }
  } else if (typeof value === "object") {
    if (Array.isArray(value)) {
      if (value.length === 0 || !value[0]) {
        _type = "List<String>";
        _default = "[]";
      } else {
        const { _o_type, _o_classes } = eqParser(_variable_name, value[0]);
        _type = `List<${_o_type}>`;
        _default = "[]";
        if (_o_classes.length > 0) {
          _classes = [..._o_classes, ..._o_classes];
        }
      }
    } else {
      _type = _class_name;

      let _o_class = `class ${_class_name} extends Equatable {\n`;
      let _o_const = `\n\n\tconst ${_class_name}({`;
      let _o_copy_with_vars = `\n\n\t\t${_class_name} copyWith({`;
      let _o_copy_with_values = `\n\n\t\t${_class_name} copyWith({`;
      let _o_props = `\t@override\n\tList<Object?> get props => [`;
      // eslint-disable-next-line no-unused-vars

      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const data = value[key];
          const { _o_type, _o_classes, _o_variable_name } = eqParser(key, data);

          const {
            _class,
            _const,
            _prop,
            _copy_with_var,
            _copy_with_value,
          } = to_eq_var(key, _o_variable_name, _o_type, false);

          _o_class += _class;
          _o_const += `\n\t\t${_const}`;
          _o_props += _prop;
          _o_copy_with_vars += _copy_with_var;
          _o_copy_with_values += _copy_with_value;

          if (_o_classes.length > 0) {
            _classes = [..._classes, ..._o_classes];
          }
        }
      }

      _classes.push(
        `${_o_class}\n\n\n\t${_o_const}\n\t});\n${_o_props}];\n}\n`.replace(
          /\n\s*\n/g,
          "\n"
        )
      );
    }
  }

  return {
    _o_type: _type,
    _o_default: _default,
    _o_variable_name: _variable_name,
    _o_classes: [...new Set(_classes)],
  };
}

export function to_eq_var(key, var_name, var_type, nullable = false) {
  return {
    _class: `\n\tfinal ${var_type} ${var_name}${!nullable ? "" : "?"};\n`,
    _const: `required this.${var_name},`,
    _prop: `${var_name},`,
    _copy_with_var: `${var_type}? ${var_name},`,
    _copy_with_value: `${var_name}: ${var_name} ?? this.${var_name},`,
  };
}

export function equatableParser(class_name, value) {
  let _type = "";
  let _classes = [];
  let _variable_name;
  let _class_name;
  let _default;

  try {
    _variable_name = to_var(class_name);
    _class_name = to_var(class_name, true);
  } catch (e) {
    console.log(e);
  }

  if (value === null) {
    _type = "String";
    _default = '""';
  } else if (typeof value === "string") {
    _type = "String";
    _default = '""';
  } else if (typeof value === "boolean") {
    _type = "boolean";
    _default = "true";
  } else if (typeof value === "number") {
    _type = "number";
    _default = "0";
  } else if (typeof value === "object") {
    if (Array.isArray(value)) {
      if (value.length === 0 || !value[0]) {
        _type = "List<String>";
        _default = "[]";
      } else {
        const { _o_type, _o_classes } = eqParser(_variable_name, value[0]);
        _type = `List<${_o_type}>`;
        _default = "[]";
        if (_o_classes.length > 0) {
          _classes = [..._o_classes, ..._o_classes];
        }
      }
    } else {
      _type = _class_name;

      let _o_class = `class ${_class_name} extends Equatable {\n`;
      let _o_const = `\n\n\tconst ${_class_name}({`;
      let _o_copy_with_vars = `\n\n\t\t${_class_name} copyWith({`;
      let _o_copy_with_values = `\n\n\t\treturn ${_class_name}(`;
      let _o_props = `\t@override\n\tList<Object?> get props => [`;

      // eslint-disable-next-line no-unused-vars
      let _o_builder = "";
      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const data = value[key];
          const { _o_type, _o_classes, _o_variable_name } = eqParser(key, data);

          const {
            _class,
            _const,
            _prop,
            _copy_with_var,
            _copy_with_value,
          } = to_eq_var(key, _o_variable_name, _o_type, false);
          _o_class += _class;
          _o_const += `\n\t\t${_const}`;
          _o_props += _prop;
          _o_copy_with_vars += _copy_with_var;
          _o_copy_with_values += _copy_with_value;

          if (_o_classes.length > 0) {
            _classes = [..._classes, ..._o_classes];
          }
        }
      }

      _classes.push(
        `${_o_class}\n\n\n\t${_o_const}\n\t});\n${_o_props}];\n}\n`.replace(
          /\n\s*\n/g,
          "\n"
        )
      );
    }
  }

  return {
    _o_type: _type,
    _o_default: _default,
    _o_variable_name: _variable_name,
    _o_classes: [...new Set(_classes)],
  };
}
